import {DEVICE} from '@chekin/guestapp-ui-kit';
import styled, {keyframes} from 'styled-components';
import {Button} from '@guestapp/old-ui-kit';
import Page from 'components/Page';
import {Box} from 'styled/common';

export const StyledBox = styled(Box)`
  width: 100%;
  height: auto;
  position: relative;
  border-top-right-radius: 0;
  border-top-left-radius: 0;

  @media (min-width: ${DEVICE.laptop}) {
    padding: 24px;
  }

  @media (min-width: ${DEVICE.laptopML}) {
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
  }
`;

export const BookingDatesBoxContainer = styled.div`
  order: 1;
  width: 100%;
`;

export const CheckinInfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${StyledBox} {
    order: 2;
  }

  @media (min-width: ${DEVICE.laptopML}) {
    display: grid;
    grid-template-columns: 1fr 65%;
    gap: 24px;
  }
`;

export const StyledPage = styled(Page)`
  gap: 24px;
  @media (min-width: ${DEVICE.laptopM}) {
    padding: 0 32px 100px;
  }
`;

export const ContentItemElement = styled.div`
  width: 100%;
  top: -24px;
  .nav-item__description {
    text-align: justify;
    max-width: 207px;
  }

  @media (min-width: ${DEVICE.laptop}) {
    .nav-item__description {
      max-width: 100%;
    }
  }
`;

const radiantPulse = keyframes`
  0% {
    box-shadow:
      0 8px 22px rgba(0, 36, 92, 0.42),
      0 0 0 0 rgba(49, 120, 255, 0.62),
      0 0 20px 2px rgba(49, 120, 255, 0.5);
  }
  70% {
    box-shadow:
      0 12px 28px rgba(0, 36, 92, 0.48),
      0 0 0 24px rgba(49, 120, 255, 0),
      0 0 32px 8px rgba(49, 120, 255, 0);
  }
  100% {
    box-shadow:
      0 8px 22px rgba(0, 36, 92, 0.42),
      0 0 0 0 rgba(49, 120, 255, 0),
      0 0 20px 2px rgba(49, 120, 255, 0);
  }
`;

export const FreeOffersButton = styled(Button)`
  bottom: 64px !important;
  z-index: 120;
  background: ${({theme}) => theme.colors.buttons.mainButtonBackground} !important;
  border-color: ${({theme}) => theme.colors.buttons.mainButtonBackground} !important;
  color: ${({theme}) => theme.colors.buttons.mainButtonTextBackground} !important;
  will-change: box-shadow;
  animation: ${radiantPulse} 1.9s ease-out infinite;
`;
